import React from "react";
import IconButton from "../buttons/IconButton";
import Avatar from "../avatar/Avatar";
import styles from "./MailCards.module.css";

const BG_BY_STATUS = {
  default: "var(--surface-tertiary)",
  late: "var(--surface-late)",
  uptodate: "var(--surface-uptodate)",
};

export const MAIL_BRAND_COLUMN_DEFAULT = 120;

export function getMailSummaryColumns(brandColumnWidth = MAIL_BRAND_COLUMN_DEFAULT) {
  return `${brandColumnWidth}px minmax(16px,1fr) 160px minmax(16px,1fr) 110px minmax(16px,1fr) 90px minmax(16px,1fr) 130px`;
}

export function getMailItemColumns(brandColumnWidth = MAIL_BRAND_COLUMN_DEFAULT) {
  return `${brandColumnWidth}px 1fr 220px 1fr 320px 1fr 40px 1fr 70px 1fr 90px 1fr 110px 1fr 170px`;
}

export const MAIL_SUMMARY_BODY_COLUMNS = getMailSummaryColumns();

export const MAIL_ITEM_FLEX = { gap: 16, brand: 120, leadId: 56, step: 40, date: 140, owner: 132 };
export const MAIL_ITEM_BODY_COLUMNS = getMailItemColumns();

function classNames(...parts) {
  return parts.filter(Boolean).join(" ");
}

function Tag({ children, color }) {
  return (
    <div className={styles.tag} style={color ? { background: color } : undefined}>
      <div className={styles.tagText}>{children}</div>
    </div>
  );
}

function OwnerCell({ src, name }) {
  return (
    <div className={styles.ownerCell}>
      <Avatar src={src} name={name} size={24} />
      <div className={styles.ownerName}>{name}</div>
    </div>
  );
}

function MailRowCard({
  status = "default",
  selected = false,
  brand,
  brandColor,
  template,
  mails,
  statusText,
  percentage,
  onAction,
  actionIcon,
  iconOnAction,
  columns,
}) {
  const bgColor = BG_BY_STATUS[status] || BG_BY_STATUS.default;

  return (
    <div className={styles.row}>
      <div
        className={styles.card}
        style={{ background: bgColor, ...(columns ? { gridTemplateColumns: columns } : undefined) }}
        onClick={(event) => {
          event.stopPropagation();
          onAction?.();
        }}
      >
        {selected && <div className={styles.selectedBorder} />}

        <div className={styles.colBrand}>
          <Tag color={brandColor}>{brand}</Tag>
        </div>

        <div className={classNames(styles.col, styles.colTemplate)}>{template}</div>
        <div className={classNames(styles.col, styles.colMails)}>{mails}</div>

        <div
          className={classNames(
            styles.col,
            styles.colStatus,
            status === "late" && styles.statusLate,
            status === "uptodate" && styles.statusUptodate,
          )}
        >
          {statusText}
        </div>

        <div className={classNames(styles.col, styles.colPercentage)}>{percentage}</div>
      </div>

      <div className={styles.actionWrap}>
        {selected && <div className={styles.selectedBorderRound} />}
        <IconButton
          icon={actionIcon}
          size="md"
          iconSize={14}
          onClick={() => iconOnAction?.()}
          aria-label="Abrir mail"
          className={styles.iconBtn}
          style={{ background: bgColor }}
        />
      </div>
    </div>
  );
}

export function MailSummaryCardRow({
  status = "default",
  selected = false,
  brand = "-",
  brandColor,
  segment = "-",
  count = "-",
  statusText = "-",
  percentage = "-",
  onAction,
  actionIcon,
  iconOnAction,
  columns = MAIL_SUMMARY_BODY_COLUMNS,
}) {
  return (
    <MailRowCard
      status={status}
      selected={selected}
      brand={brand}
      brandColor={brandColor}
      template={segment}
      mails={count}
      statusText={statusText}
      percentage={percentage}
      onAction={onAction}
      actionIcon={actionIcon}
      iconOnAction={iconOnAction}
      columns={columns}
    />
  );
}

export function MailItemCardRow({
  status = "default",
  brand = "-",
  brandColor,
  campaign = "-",
  subject = "-",
  step = "-",
  activeStatus = "-",
  responseStatus = "-",
  datetime = "-",
  ownerName = "-",
  ownerAvatar,
  onAction,
  iconOnAction,
  actionIcon,
  columns = MAIL_ITEM_BODY_COLUMNS,
}) {
  const bgColor = BG_BY_STATUS[status] || BG_BY_STATUS.default;
  return (
    <div className={styles.row}>
      <div
        className={styles.itemCard}
        style={{ background: bgColor, gridTemplateColumns: columns }}
        onClick={(event) => { event.stopPropagation(); onAction?.(); }}
      >
        <div style={{ gridColumn: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Tag color={brandColor}>{brand}</Tag>
        </div>
        <div className={styles.itemText} style={{ gridColumn: 3 }}>{campaign}</div>
        <div className={styles.itemText} style={{ gridColumn: 5 }}>{subject}</div>
        <div className={styles.itemText} style={{ gridColumn: 7 }}>{step}</div>
        <div className={styles.itemText} style={{ gridColumn: 9 }}>{activeStatus}</div>
        <div className={styles.itemText} style={{ gridColumn: 11 }}>{responseStatus}</div>
        <div className={styles.itemText} style={{ gridColumn: 13 }}>{datetime}</div>
        <div style={{ gridColumn: 15 }}>
          <OwnerCell src={ownerAvatar} name={ownerName} />
        </div>
      </div>
      <div className={styles.actionWrap}>
        <IconButton
          icon={actionIcon}
          size="md"
          iconSize={14}
          onClick={(event) => { event.stopPropagation(); iconOnAction?.(); }}
          aria-label="Abrir mail"
          className={styles.iconBtn}
          style={{ background: bgColor }}
        />
      </div>
    </div>
  );
}
